import { useEffect, useState } from 'react';

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const scrollTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={scrollTop}
      aria-label="返回顶部"
      className="fixed bottom-6 right-4 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-700 md:right-6"
    >
      <span className="flex h-5 w-5 items-center justify-center">
        <i className="ri-arrow-up-line text-xl" />
      </span>
    </button>
  );
}